const MIN_PROGRESS_BAR_PERCENT = 2.5;

type Props = {
    percentage: number;
};

export const ProgressBar = ({ percentage }: Props) => (
    <div className="h-2xs w-full bg-border-secondary">
        <div
            className="h-2xs bg-critical-500 transition-all duration-200"
            data-testid="timed-plus-in-progress-progress"
            style={{ width: `${Math.max(percentage, MIN_PROGRESS_BAR_PERCENT)}%` }}
        />
    </div>
);
